import { render, staticRenderFns } from "./alarm_center_report_log.vue?vue&type=template&id=ca588130&scoped=true"
import script from "./alarm_center_report_log.vue?vue&type=script&lang=js"
export * from "./alarm_center_report_log.vue?vue&type=script&lang=js"
import style0 from "./alarm_center_report_log.vue?vue&type=style&index=0&id=ca588130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca588130",
  null
  
)

export default component.exports